import { queryKeys } from 'api/consts'
import { queryClient } from 'contexts/reactQuery'

export const invalidateOnboardingTipsQuery = () =>
  queryClient.invalidateQueries({
    queryKey: [queryKeys.onboardingTips],
  })
